import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=3c8afaa6&"
import script from "./Create.vue?vue&type=script&lang=js&"
export * from "./Create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\invoiceasy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c8afaa6')) {
      api.createRecord('3c8afaa6', component.options)
    } else {
      api.reload('3c8afaa6', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=3c8afaa6&", function () {
      api.rerender('3c8afaa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/expenses/Create.vue"
export default component.exports